import { bianka } from '@fiverr-private/obs';
import { Impression, Click, ClickType, ElementType } from '@fiverr-private/bianka_js';
import { ViewedPromotionBanner } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/black_friday/viewed_promotion_banner';
import { ClickedOnPromotionBanner } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/black_friday/clicked_on_promotion_banner';
import {
    ComponentType,
    ElementName,
} from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/black_friday/common';

const EVENT_SOURCE = 'holiday_promotion_banner';
const COMPONENT_NAME = 'holiday_promotion_banner';

export const reportViewedBlackFridayBanner = (text: string) => {
    bianka.reportActivity<Impression>({
        type: Impression,
        event: {
            type: 'viewed_promotion_banner',
            component: {
                impId: Date.now().toString(),
                level: 1,
                isLeaf: true,
                positionInParent: 1,
                numberOfElements: 1,
                sizeInParent: 1,
                visibleThroughScroll: true,
                name: COMPONENT_NAME,
            },
        },
        additionalData: {
            type: ViewedPromotionBanner,
            message: {
                component: {
                    name: COMPONENT_NAME,
                    type: ComponentType.BANNER,
                    text,
                },
                eventSource: EVENT_SOURCE,
            },
        },
    });
};

export const reportClickedCloseIcon = (text: string) => {
    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_on_promotion_banner',
            clickType: ClickType.UNSPECIFIED,
            element: {
                name: 'close_icon',
                type: ElementType.BUTTON,
                numberOfElements: 1,
            },
        },
        additionalData: {
            type: ClickedOnPromotionBanner,
            message: {
                component: {
                    name: COMPONENT_NAME,
                    type: ComponentType.BUTTON,
                    text,
                },
                eventSource: EVENT_SOURCE,
                elementName: ElementName.CLOSE_ICON,
            },
        },
    });
};

export const reportClickedTermsConditionsLink = (text: string) => {
    bianka.reportActivity<Click>({
        type: Click,
        event: {
            type: 'clicked_on_promotion_banner',
            clickType: ClickType.UNSPECIFIED,
            element: {
                name: 'terms_conditions_link',
                type: ElementType.LINK,
                numberOfElements: 1,
            },
        },
        additionalData: {
            type: ClickedOnPromotionBanner,
            message: {
                component: {
                    name: COMPONENT_NAME,
                    type: ComponentType.LINK,
                    text,
                },
                eventSource: EVENT_SOURCE,
                elementName: ElementName.TERMS_CONDITIONS_LINK,
            },
        },
    });
};
